// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 664 ? "reactPlayerPreview" : chunkId) + "." + {"63":"17943eb0baef8fdc","95":"57f91e3868d66cdc","187":"cd7db46d0bcc875c","318":"c88d389882320004","664":"4903b54ebee682e0"}[chunkId] + ".js";
};